import { render, staticRenderFns } from "./QuizWordSearchMobile.vue?vue&type=template&id=0193e87d"
import script from "./QuizWordSearchMobile.vue?vue&type=script&lang=js"
export * from "./QuizWordSearchMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports